/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_IntroInputs */

const en_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is built and maintained by Choi JY, a developer who works with JSON every day and got tired of pasting production data into tools that upload it somewhere. If something here is broken, confusing, or missing, I want to hear about it.`)
};

const ko_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 매일 JSON을 다루는 개발자 Choi JY가 만들고 운영합니다. 운영 데이터를 어딘가로 업로드하는 도구에 붙여넣는 일에 지쳐서 직접 만들었습니다. 이 사이트에서 고장 났거나 헷갈리거나 빠진 것이 있다면 알려주세요.`)
};

const ja_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON は、毎日 JSON を扱う開発者 Choi JY が作り、運営しています。本番データをどこかにアップロードするツールに貼り付けるのが嫌になって自分で作りました。壊れている、分かりにくい、足りない、そう感じたところがあれば教えてください。`)
};

/**
* | output |
* | --- |
* | "PureJSON is built and maintained by Choi JY, a developer who works with JSON every day and got tired of pasting production data into tools that upload it som..." |
*
* @param {Contact_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_intro = /** @type {((inputs?: Contact_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_intro(inputs)
	if (locale === "ko") return ko_contact_intro(inputs)
	return ja_contact_intro(inputs)
});